import * as React from "react";
import * as d3 from "./assets/d3";
import { select, selectAll } from "d3-selection";
export default class Ygrid extends React.PureComponent {
    constructor(props) {
        super(props);
        const { yScale, width, labelHeight, height } = this.props;
        const yGrid = d3
            .axisLeft(yScale)
            .tickSize(-width)
            .ticks(Math.floor(height / (4 * labelHeight)))
            .tickFormat("");
        this.state = {
            yGrid,
        };
    }
    componentDidMount() {
        select(this.arc).call(this.state.yGrid);
        selectAll(".focus-grafos-grid line").attr("stroke", "#ddd");
        selectAll(".focus-grafos-grid path").attr("stroke", "#fff");
    }
    componentDidUpdate() {
        const { yScale, width, height, labelHeight } = this.props;
        select(this.arc).call(this.state.yGrid
            .scale(yScale)
            .tickSize(-width)
            .ticks(Math.floor(height / (4 * labelHeight))));
        selectAll(".focus-grafos-grid.y2 line")
            .attr("stroke", "#ddd")
            .attr("stroke-dasharray", "5");
    }
    render() {
        const { margins, yId } = this.props;
        const t = `translate(${margins.left},0)`;
        return (React.createElement("g", { className: `focus-grafos-grid ${yId}`, transform: t, ref: (ref) => {
                this.arc = ref;
            } }));
    }
}
//# sourceMappingURL=Ygrid.js.map